import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Editorial "KNOW A CHEAPER WAY?" call-to-action used across empty states + page footers.
export function CheaperWayCTA({ category, compact }) {
  const to = category ? `/recommend?category=${encodeURIComponent(category)}` : "/recommend";
  if (compact) {
    return (
      <Link
        to={to}
        data-testid="cheaper-way-cta"
        className="group inline-flex items-center gap-2 font-label text-xs tracking-widest text-[#EF3340] hover:text-[#F4EEE5] transition-colors"
      >
        KNOW A CHEAPER WAY? RECOMMEND IT
        <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
      </Link>
    );
  }
  return (
    <section data-testid="cheaper-way-cta-block" className="border-2 border-[#EF3340] bg-[#141217] p-8 md:p-10">
      <div className="eyebrow mb-3">KNOW A CHEAPER WAY?</div>
      <h3 className="font-display text-3xl md:text-4xl leading-[0.95] mb-3">YOU MISSED THIS?</h3>
      <p className="font-serif text-lg text-stone-300 max-w-xl mb-6">
        Know a source, service, deal, or resource we missed? Send it our way — you might help someone find a cheaper way.
      </p>
      <Link
        to={to}
        data-testid="recommend-it-btn"
        className="group inline-flex items-center gap-2 font-label text-xs tracking-widest bg-[#EF3340] text-white px-6 py-4 hover:bg-[#cc2a35] transition-colors"
      >
        RECOMMEND IT <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
      </Link>
    </section>
  );
}

// Empty / COMING SOON state for a category with nothing catalogued yet.
export function ComingSoon({ category, title = "COMING SOON", line = "We're building this part of THE CHEAPER WAY." }) {
  return (
    <div data-testid="coming-soon" className="border hairline bg-[#141217] p-8 md:p-12 text-center">
      <div className="eyebrow mb-4 text-[#EF3340]">{title}</div>
      <p className="font-serif text-xl text-stone-200 mb-2">{line}</p>
      <p className="font-serif text-lg text-stone-400 mb-6">Know somewhere we should look?</p>
      <Link
        to={category ? `/recommend?category=${encodeURIComponent(category)}` : "/recommend"}
        data-testid="coming-soon-recommend-btn"
        className="inline-flex items-center gap-2 font-label text-xs tracking-widest bg-[#EF3340] text-white px-6 py-4 hover:bg-[#cc2a35] transition-colors"
      >
        RECOMMEND A SOURCE <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  );
}
